"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Socialtwitter = function Socialtwitter(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "SocialtwitterTitle SocialtwitterDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "SocialtwitterTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "SocialtwitterDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M19.948 6.62a6.435 6.435 0 0 1-1.858.51 3.24 3.24 0 0 0 1.422-1.79 6.486 6.486 0 0 1-2.053.786 3.234 3.234 0 0 0-5.51 2.95 9.183 9.183 0 0 1-6.668-3.38 3.232 3.232 0 0 0 1.001 4.318 3.225 3.225 0 0 1-1.465-.404v.04a3.237 3.237 0 0 0 2.595 3.172 3.252 3.252 0 0 1-1.461.055 3.238 3.238 0 0 0 3.02 2.246 6.488 6.488 0 0 1-4.787 1.34 9.152 9.152 0 0 0 4.957 1.452c5.95 0 9.202-4.928 9.202-9.202 0-.14-.003-.28-.009-.419a6.55 6.55 0 0 0 1.614-1.673z",
    fill: "#00ACED"
  }));
};

Socialtwitter.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Socialtwitter.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Socialtwitter;
exports["default"] = _default;